module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"General":"Настройки","Subscription":"Подписка","Danger Zone":"Сброс и Удаление аккаунта","Changelog":"Изменения","entered_as":"Вы вошли как <b>{0}</b>"},"en":{"entered_as":"Logged in as <b>{0}</b>"}}')
  delete Component.options._Ctor
}
